<template>
    <div class="my-search">
        <el-input placeholder="请输入关键字" v-model="title" @focus="isActive = true" @blur="isActive = false" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <div :class="['search-box' , {active: isActive}]" @click="sarch">
            搜索
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            isActive: false,
            title: '',
        };
    },
    mounted() {},
    methods: {
        sarch() {
            this.$emit('search', this.title);
        },
        //获取焦点时触发
        focusHead() {
            this.isActive = true;
        },
        //失去
        blurHead() {
            this.isActive = false;
        },
    },
};
</script>

<style lang="scss" scoped>
$primayColor: #8a1f94;
$huiColor: #b5b5b5;

.my-search {
    width: 750px;
    height: 50px;
    margin: 0 auto;
    position: relative;

    ::v-deep .el-input__inner {
        border-radius: 0; // 去除圆角
        font-size: 20px;
        height: 50px;
        padding-left: 40px;

        border-color: $primayColor; //边框的颜色
        padding-right: 140px;
    }
    //搜索图标
    ::v-deep .el-input__icon {
        height: 100%;
        line-height: 50px;
        padding-left: 8px;
        font-size: 20px;
    }
    //清空按钮
    ::v-deep .el-input__suffix {
        padding-right: 110px;
    }

    //搜索按钮
    .search-box {
        width: 100px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 20px;
        font-weight: bold;
        // color: $huiColor;
        // border-left: 1px solid $huiColor;
        color: $primayColor; //选中颜色
        border-left: 1px solid $primayColor;

        position: absolute;
        right: 1px;
        bottom: 12px;
        cursor: pointer;
    }
    .active {
        color: $primayColor;
        border-left: 1px solid $primayColor;
    }
}
</style>
